import React from 'react';

function DefaultLoading() {
	return <span className="loader">Loading...</span>;
}

export default DefaultLoading;
